import { actions } from 'components/Teams/reducer';
import { pageNum } from 'appConstants';
export const useTeamDetailsHandlers = ({ teamsDispatch }) => {
  const initialSortColumn = 'userName';

  const handlePageChange = (_event, newPage) => {
    teamsDispatch({
      type: actions.updateUsersTableParams,
      payload: { page: newPage },
    });

    teamsDispatch({ type: actions.setShouldFetchUsers, fetch: true });
  };

  const handleChangeRowsPerPage = (event) => {
    teamsDispatch({
      type: actions.updateUsersTableParams,
      payload: { rowsPerPage: event.target.value, page: pageNum.ZERO },
    });

    teamsDispatch({ type: actions.setShouldFetchUsers, fetch: true });
  };

  const handleSortChange = (column, direction) => {
    let columnId = null;
    let dir = null;
    let sort = `+${initialSortColumn}`;
    let field = initialSortColumn;
    if (column) {
      columnId = column.id;
      dir = direction;
      ({ field } = column);
      sort = direction === 'asc' ? `+${field}` : `-${field}`;
    }

    teamsDispatch({
      type: actions.updateUsersTableParams,
      payload: {
        sortColumnId: columnId,
        sortDirection: dir,
        sort,
        field,
        page: pageNum.ZERO,
      },
    });

    teamsDispatch({ type: actions.setShouldFetchUsers, fetch: true });
  };

  const handleFilterChange = (filterData) => {
    teamsDispatch({
      type: actions.updateUsersTableFilter,
      payload: filterData,
    });

    teamsDispatch({
      type: actions.updateUsersTableParams,
      payload: { page: pageNum.ZERO },
    });

    teamsDispatch({ type: actions.setShouldFetchUsers, fetch: true });
  };

  const handleClearFilter = () => {
    teamsDispatch({ type: actions.resetTeamUsersFilter });
    teamsDispatch({
      type: actions.updateUsersTableParams,
      payload: {},
    });

    teamsDispatch({ type: actions.setShouldFetchUsers, fetch: true });
  };

  return {
    handlePageChange,
    handleChangeRowsPerPage,
    handleSortChange,
    handleFilterChange,
    handleClearFilter,
  };
};
